import { FC } from 'react';

import { router } from '@inertiajs/react';

import { ProductCardToggle } from './ProductCardToggle';
import {
    Offer,
    OfferActionQuantity,
    OfferActionTypes,
    PremiumSummary,
} from '../../../../types';
import { ConfirmModalState } from '../../../../types/ui';
import {
    buildProfileOfferEditPath,
    saveProfileOffersReturnContext,
} from '../__shared/returnContext';
interface Props {
    offers: Offer[];
    loadedPages: number;
    premiumSummary: PremiumSummary;
    selectedOffers: number[];
    loading: boolean;
    toggleOfferSelection: (offerId: number) => void;
    setConfirmModalState: (state: ConfirmModalState) => void;
    activatingOfferId: number | null;
    onPremiumActivationRequest: (offer: Offer) => void;
}

export const OffersGrid: FC<Props> = ({
    offers,
    loadedPages,
    premiumSummary,
    selectedOffers,
    loading,
    toggleOfferSelection,
    setConfirmModalState,
    activatingOfferId,
    onPremiumActivationRequest,
}) => {
    return (
        <div className="mb-6 grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5">
            {offers.map((offer) => (
                <ProductCardToggle
                    key={offer.id}
                    product={offer.product}
                    price={offer.price}
                    amount={offer.amount}
                    loading={loading}
                    toggled={selectedOffers.includes(offer.id)}
                    onToggle={() => toggleOfferSelection(offer.id)}
                    actions={[
                        ...(premiumSummary.availableSlotsCount > 0
                            ? [
                                  {
                                      label:
                                          activatingOfferId === offer.id
                                              ? 'Активуємо...'
                                              : offer.premium_active
                                                ? 'Продовжити premium'
                                                : 'Premium 7 днів',
                                      mobileLabel:
                                          activatingOfferId === offer.id ||
                                          !offer.premium_active
                                              ? undefined
                                              : 'Premium',
                                      bg: 'primary',
                                      className:
                                          'border-2 border-amber-400 bg-white font-semibold text-amber-700 shadow-sm hover:bg-amber-50',
                                      text: 'amber-700',
                                      action: () => {
                                          if (activatingOfferId === offer.id) {
                                              return;
                                          }

                                          onPremiumActivationRequest(offer);
                                      },
                                  },
                              ]
                            : []),
                        {
                            label: 'Редагувати',
                            bg: 'secondary',
                            text: 'foreground',
                            action: () => {
                                saveProfileOffersReturnContext(loadedPages);
                                router.get(buildProfileOfferEditPath(offer.id));
                            },
                        },
                        {
                            label: 'Видалити',
                            bg: 'primary',
                            text: 'white',
                            action: () => {
                                setConfirmModalState({
                                    open: true,
                                    payload: {
                                        type: OfferActionTypes.Delete,
                                        quantity: OfferActionQuantity.Single,
                                        offerId: offer.id,
                                    },
                                });
                            },
                        },
                    ]}
                    eagerLoadImage
                />
            ))}
        </div>
    );
};
